import { NavItem } from "./Common/NavItem";

const navItems: NavItem[] = [
  {
    id: 1,
    idnm: "home",
    navheading: "menu.home",
    type: "home",
  },
  {
    id: 2,
    idnm: "trips",
    navheading: "menu.tours",
    type: "home",
  },
  {
    id: 3,
    idnm: "booking",
    navheading: "menu.booking",
    type: "home",
  },
  {
    id: 4,
    idnm: "contact",
    navheading: "menu.contact",
    type: "home",
  },
  {
    id: 5,
    idnm: "gallery",
    href: "/gallery",
    navheading: "menu.gallery",
    type: "outside-home",
  },
  {
    id: 6,
    idnm: "affiliates",
    href: "/affiliates",
    navheading: "menu.affiliates",
    type: "outside-home",
  },
];

export { navItems };
